/**
 * This class handles the logic for the additional taxonomy terms that are configured for the Program post type.
 * For example "sport" taxonomy.
 *
 * When a user selects a parent term through a specific field dropdown, we show that terms child terms as a checkbox list.
 */
class programGeneralTermSelection {
	constructor() {
		acf.addAction( 'ready', () => {
			// Store information about our different select fields for use later.
			acf.set( 'parentFields', {
				modernaSprak: 'field_63d8030eede54',
				individualChoice: 'field_63d80c87f6d34',
			} );
			acf.set( 'childFields', {
				modernaSprak: 'field_63d8030eede55',
				individualChoice: 'field_63d80c87f6d35',
			} );
			// Trigger our logic application
			this.applyChildSelectionLogic();
		} );
	}

	/**
	 * Applies the logic to our ACF taxonomy fields.
	 */
	applyChildSelectionLogic = () => {
		// Hook into select2 preparation of AJAX data.
		acf.add_filter( 'select2_ajax_data', ( data, args, $input, field, instance ) => { // eslint-disable-line no-unused-vars
			const fieldKey = args?.field?.data?.key;
			// Bail if we found no field key.
			if ( ! fieldKey ) {
				return data;
			}

			const parentFields = acf.get( 'parentFields' );
			const childFields = acf.get( 'childFields' );
			// Let's just add our logic if its a child term.
			if ( Object.values( childFields ).includes( fieldKey ) ) {
				const taxonomyKey = this.getKeyByValue( childFields, fieldKey );
				return this.addParentTermToSelect2Data( data, fieldKey, taxonomyKey, parentFields, childFields, instance );
			}

			// If it's not a child term we now want to check if its a parent term and we should add the change event check.
			// this ensures that if the parent term is changed, we reset the child terms.

			// Bail if the field is not a parent field.
			if ( ! Object.values( parentFields ).includes( fieldKey ) ) {
				return data;
			}

			const taxonomyKey = this.getKeyByValue( parentFields, fieldKey );

			// First we want to check for when a field is changed. If it is, and its a parent field, we need to reset the child field.
			instance.on( 'change', instance.$el, () => {
				// Get the child field with the same key as the parent and that resides within the same repeater row.
				const childFieldObjects = acf.findFields( {
					key: childFields[ taxonomyKey ],
					parent: instance.$el.closest( '.acf-row' ),
				} );

				// reset child dropdown if we found one.
				if ( childFieldObjects.length > 0 ) {
					childFieldObjects.find( 'select' ).val( '' ).change();
				}
			} );

			return data;
		} );
	};

	/**
	 * Adds the parent term select fields data to the data sent through the select2 AJAX request.
	 *
	 * @param {Object} data         The data sent to the backend
	 * @param {string} fieldKey     The field key
	 * @param {string} taxonomyKey  The taxonomy key
	 * @param {Object} parentFields The parent fields object
	 * @param {Object} childFields  The child fields object
	 * @param {Object} instance     The field instance
	 */
	addParentTermToSelect2Data = ( data, fieldKey, taxonomyKey, parentFields, childFields, instance ) => { // eslint-disable-line no-unused-vars
		// Bail early if this isnt a child field.
		if ( ! Object.values( childFields ).includes( fieldKey ) ) {
			return data;
		}

		// Get the parent field with the same key as the child and that resides within the same repeater row.
		const parentFieldObjects = acf.findFields( {
			key: parentFields[ taxonomyKey ],
			parent: instance.$el.closest( '.acf-row' ),
		} );

		// reset child dropdown if we found one.
		if ( parentFieldObjects.length > 0 ) {
			data.parentTerm = parentFieldObjects.find( 'select' ).val();
		}

		return data;
	};

	/**
	 * Get the key from an array based on the value in the pair.
	 *
	 * @param {Object} object the object we are looking in
	 * @param {string} value  the value string we want to find the key for
	 */
	getKeyByValue = ( object, value ) => {
		return Object.keys( object ).find( key => object[ key ] === value );
	};
}

export default programGeneralTermSelection;
